import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col items-center"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-xl font-medium mb-2"
}, "订单已支付成功", -1);
import router from '@/router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Success',
  setup(__props) {
    const clickBackHome = () => {
      router.replace('/');
      setTimeout(() => {
        location.reload();
      }, 100);
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_icon, {
        name: "passed",
        color: "green",
        size: "45",
        class: "mt-24 mb-6"
      }), _hoisted_2, _createVNode(_component_van_button, {
        type: "primary",
        class: "mt-2",
        onClick: clickBackHome
      }, {
        default: _withCtx(() => [_createTextVNode("返回首页")]),
        _: 1
      })]);
    };
  }
});